import { render, staticRenderFns } from "./IndexContent3.vue?vue&type=template&id=1bf01b89&scoped=true"
import script from "./IndexContent3.vue?vue&type=script&lang=js"
export * from "./IndexContent3.vue?vue&type=script&lang=js"
import style0 from "./IndexContent3.vue?vue&type=style&index=0&id=1bf01b89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf01b89",
  null
  
)

export default component.exports